import React, { useEffect, useMemo, useState } from 'react';
import { Smartphone, ShieldAlert } from 'lucide-react';
import { getPlatformInfo } from '../utils/platformDetection';

const isLocalEnvironment = () => {
  const hostname = window.location.hostname;
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname.endsWith('.local');
};

export default function DesktopBlocker({ children }) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const platform = useMemo(() => getPlatformInfo(), []);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const shouldBlock = !isLocalEnvironment() && (platform.isDesktop || windowWidth >= 1024);

  if (!shouldBlock) {
    return children;
  }

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <div style={styles.iconRow}>
          <ShieldAlert size={42} />
          <Smartphone size={42} />
        </div>
        <h1 style={styles.title}>Acesso restrito</h1>
        <p style={styles.text}>
          Este aplicativo foi liberado apenas para celular ou tablet.
        </p>
        <p style={styles.subtext}>
          Abra pelo seu dispositivo móvel para continuar usando o app.
        </p>
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#12121f',
    padding: '24px',
    boxSizing: 'border-box',
  },
  card: {
    width: '100%',
    maxWidth: '420px',
    background: '#1a1a2e',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: '18px',
    padding: '28px 22px',
    color: '#f5f5f5',
    textAlign: 'center',
    boxShadow: '0 16px 50px rgba(0,0,0,0.35)',
  },
  iconRow: {
    display: 'flex',
    gap: '14px',
    justifyContent: 'center',
    color: '#9f7aea',
    marginBottom: '16px',
  },
  title: {
    margin: '0 0 12px 0',
    fontSize: '28px',
  },
  text: {
    margin: '0 0 10px 0',
    fontSize: '16px',
    lineHeight: 1.5,
    color: '#ececf3',
  },
  subtext: {
    margin: 0,
    fontSize: '14px',
    lineHeight: 1.5,
    color: '#b8b8c7',
  },
};
